
//! bu ekranda gözükürken olan
const getEslestir = ({loadList, aracItem}) => {

    const aracType = aracItem?.devamliAraclar?.devamliAraclarPlakas?.$values[0]?.truckType
    const aracTypeId = aracItem?.devamliAraclar?.devamliAraclarPlakas?.$values[0]?.truckTypeId


    const cities = aracItem?.gunlukAracListesiCityCanGos?.map(item => item?.cityCanGo)
    const filtered = loadList?.filter(item => {
        const city = item?.routePoints?.$values[item?.routePoints?.$values?.length -1]?.city
        const loadTruckTypeId = item?.truckTypeId
        return (cities?.includes(city) && (loadTruckTypeId >= aracTypeId || aracTypeId === 6))
    })
    return filtered
}

export default getEslestir